import { Record, List } from 'immutable';

export default class AreaRecord extends Record({
  id: undefined,
  coordinates: new List(),
  distance: undefined,
  name: undefined,
  geoCode: undefined,
  secondaryName: undefined,
  type: undefined,
}) {
}
